<div *ngIf="!loading" [ngClass]="styling.wrapper()" [ngStyle]="styling.wrapperInline()">
    <ng-content></ng-content>
</div>

<div *ngIf="loading" [ngClass]="styling.loading()" [style.width]="styling.loadingWidth()"></div>
